<!--
  SendGnssFloatBtn.vue
    GNSS情報送信ボタン Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-fab-transition>
    <v-btn
      color="blue lighten-1"
      dark
      absolute
      right
      fab
      v-show="mVisible"
      @click="send"
    >
      <v-icon>send</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'

export default {
  name: 'SendGnssFloatBtn',
  data: () => ({
    // nothing
  }),
  mounted: function () {
    this.$log.debug('# SendGnssFloatBtn')
  },
  destroyed: function () {
    this.$log.debug('# SendGnssFloatBtn')
  },
  computed: {
    ...mapState({
      mVisible: state => state.sSendGnssVisible
    }),
  },
  methods: {
    send: function () {
      this.$emit('sendGnss')
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/parts/SendGnssFloatBtn.vue